import React from 'react';
import styles from './JourneySections.module.scss';
import { classNameGenerator } from '@/utils';
import { useRouter } from 'next/router';

const JourneySections = () => {
    const cls = classNameGenerator(styles)
    const router = useRouter();
    return (
        <div className={cls("journey-container")}>
            {/* Banner Section */}
            <section className={cls("personalized-banner")}>
                <div className={cls("banner-content")}>
                    <span className={cls("overline")}>PERSONALIZED NUTRITION</span>
                    <h1>Get a plan built for you</h1>
                    <p>
                        Talk to our Nutritionists to create a nutrition plan tailored to your lifestyle, health needs and goals. Discover the power of eating right!
                    </p>
                    <button onClick={() => router.push("https://www.betheshyft.com/plans/nutrition/")} className={cls("btn-white")}>Start your journey</button>
                </div>
            </section>

            {/* Community Section */}
            <section className={cls("community-section")}>
                <div className={cls("community-grid")}>
                    <div className={cls("image-wrapper")}>
                        <img
                            src="https://d1mxd7n691o8sz.cloudfront.net/static/mindhouse/imagerepo/2026-04/ImageWithFalback-af203adaa42040108a570b132e0c2293.png"
                            alt="Community and activity"
                        />
                    </div>
                    <div className={cls("text-wrapper")}>
                        <span className={cls("overline")}>COMMUNITY</span>
                        <h2>50,000 people already showing up every day.</h2>
                        <p>
                            Join the Shyft WhatsApp community. Share your goals, track your streaks,
                            and stay accountable.
                        </p>
                        <button onClick={() => router.push("https://www.betheshyft.com/joincommunity/?utm_source=shyft_website&utm_medium=header-button&adset_name=top_navbar")} className={cls("btn-black")}>Start your journey</button>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default JourneySections;